module.exports = __webpack_public_path__ + "static/media/鄂A123456.08af4121.jpg";